// extracted by mini-css-extract-plugin
export default {"container":"Signup_container__LtlvZ","btn-signup":"Signup_btn-signup__PtHek","box-signup":"Signup_box-signup__xLUUg","form-input":"Signup_form-input__M43Qc"};